/**
 * Created by ruslan on 27.06.17.
 */
export { default as TabBarScrollIndicator} from './Indicator';
export { default as TabBarScrollInner} from './Inner';
export { default as TabBarScrollFrame} from './ScrollFrame';
export { default as TabBarScroll} from './TabBar';


// WEBPACK FOOTER //
// ./src/react-material-components-demo/lib/Tabs/scroller/index.js